import { render } from "./ArticleBase.vue?vue&type=template&id=2baa60f4&scoped=true"
import script from "./ArticleBase.vue?vue&type=script&lang=js"
export * from "./ArticleBase.vue?vue&type=script&lang=js"

import "./ArticleBase.vue?vue&type=style&index=0&id=2baa60f4&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/kama-dugri/kama-dugri/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baa60f4"]])

export default __exports__